import type { OrgProjectScope } from "@/lib/resource-context";
import type { ProjectSuggestionListParams } from "../types";

export const projectSuggestionsKeys = {
  all: (scope: OrgProjectScope) =>
    ["project_suggestions", scope.organizationId, scope.projectId] as const,
  list: (scope: OrgProjectScope, params: ProjectSuggestionListParams) =>
    [...projectSuggestionsKeys.all(scope), "list", params] as const,
};
